module.exports = __webpack_public_path__ + "static/media/sf-test-7.1034003f.mp3";